import React from "react";
import {Grid, Row, Col, ButtonGroup} from "react-bootstrap";
import ReactLoading from 'react-loading';
import Component from "./components/AscComponent";
import {withRouter} from "react-router-dom";
import Routes from "./AscRoutes";
import Header from "./containers/Elements/Header/Header";
import SideBar from "./containers/Elements/SideBar/SideBar";
import "./App.css";
import Gitversion from './GitVersion.json';
import * as GlobalConst from "./components/AscConstants";

// ユーザー設定（cm97）
const USER_SETTING_FUNCTION_ID_PLAYBACK = "PLAYBACK";
const USER_SETTING_PARAM_ID_AUDIO_SPEED = "AUDIO_SPEED";
const USER_SETTING_PARAM_ID_AUTO_SCROLL = "AUTO_SCROLL";
const USER_SETTING_FUNCTION_ID_DOWNLOAD = "DOWNLOAD";
const USER_SETTING_PARAM_ID_ADD_CALL_HISTORY_ID = "ADD_CALL_HISTORY_ID";

// Reactで画像表示する場合css上でのbackgroundimage使用不可(画像が呼べない)
// headerとAppのみ特例でStyle直書きしてます

// BtoCは"./image/bg_c.jpg"使用。BtoBは"./image/bg_b.jpg"使用

// import loginImg from "./image/bg_c.jpg";
import loginImg_Mini from "./image/logInMini.png";


const tryRequire = path => {
    try {
        return require(path);
    } catch (e) {
        return null;
    }
};

class App extends Component {
    constructor(props) {
        super(props);

        // ヘッダー部の高さを固定
        let headerHeight = 65

        this.state = {
            lang: "ja",
            isAuthenticated: false,
            isAuthenticating: true,
            headerHeight: headerHeight,
            width: window.innerWidth,
            appHeight: window.innerWidth < 768 ? "100%" : window.innerHeight - headerHeight,
            tableHeight: window.innerHeight - headerHeight - 85,
            userInfo: {},
            historyLock: false,
            userCompanyControlParameters: {},
            systemParameters: {},
            notification_flag: false,
            notifications: [],
            downloadSettings: { addCallHistoryId: false }
        }
        this.getSystemParameters();
    }

    // 再生設定をDBから取得（失敗時は 1 と false を使用）
    loadPlaybackSettings = async () => {
        try {
            const [speedRes, autoRes] = await Promise.all([
                this.getUserSettingParameter({
                    function_id: USER_SETTING_FUNCTION_ID_PLAYBACK,
                    parameter_id: USER_SETTING_PARAM_ID_AUDIO_SPEED
                }),
                this.getUserSettingParameter({
                    function_id: USER_SETTING_FUNCTION_ID_PLAYBACK,
                    parameter_id: USER_SETTING_PARAM_ID_AUTO_SCROLL
                })
            ]);

            const audioSpeed = (speedRes && speedRes.data && speedRes.data.parameter_value)
                ? parseFloat(speedRes.data.parameter_value)
                : 1;
            const autoScroll = (autoRes && autoRes.data && autoRes.data.parameter_value)
                ? autoRes.data.parameter_value === 'Y'
                : false;

            this.setState({ playbackSettings: { audioSpeed, autoScroll } });
        } catch (e) {
            // Fallback to defaults
            this.setState({ playbackSettings: { audioSpeed: 1, autoScroll: false } });
        }
    }

    // 再生設定をDBへ保存し、成功時はグローバル状態を更新
    savePlaybackSettings = async ({ audioSpeed, autoScroll }) => {
        try {
            await Promise.all([
                this.upsertUserSetting({
                    function_id: USER_SETTING_FUNCTION_ID_PLAYBACK,
                    parameter_id: USER_SETTING_PARAM_ID_AUDIO_SPEED,
                    parameter_value: String(audioSpeed),
                    memo: null
                }),
                this.upsertUserSetting({
                    function_id: USER_SETTING_FUNCTION_ID_PLAYBACK,
                    parameter_id: USER_SETTING_PARAM_ID_AUTO_SCROLL,
                    parameter_value: autoScroll ? 'Y' : 'N',
                    memo: null
                })
            ]);
            this.setState({ playbackSettings: { audioSpeed, autoScroll } });
            return true;
        } catch (e) {
            return false;
        }
    }

    // ダウンロード設定をDBから取得
    loadDownloadSettings = async () => {
        try {
            const res = await this.getUserSettingParameter({
                function_id: USER_SETTING_FUNCTION_ID_DOWNLOAD,
                parameter_id: USER_SETTING_PARAM_ID_ADD_CALL_HISTORY_ID
            });
            const addCallHistoryId = (res && res.data && res.data.parameter_value)
                ? res.data.parameter_value === 'Y'
                : false;
            this.setState({ downloadSettings: { addCallHistoryId } });
        } catch (e) {
            this.setState({ downloadSettings: { addCallHistoryId: false } });
        }
    }

    // ダウンロード設定をDBへ保存し、成功時はグローバル状態を更新
    saveDownloadSettings = async ({ addCallHistoryId }) => {
        try {
            await this.upsertUserSetting({
                function_id: USER_SETTING_FUNCTION_ID_DOWNLOAD,
                parameter_id: USER_SETTING_PARAM_ID_ADD_CALL_HISTORY_ID,
                parameter_value: addCallHistoryId ? 'Y' : 'N',
                memo: null
            });
            this.setState({ downloadSettings: { addCallHistoryId } });
            return true;
        } catch (e) {
            return false;
        }
    }

    async getSystemParameters() {

        let domain = window.location.href;

        //　ドメインの前の「https://」削除、「/SignIn」などコントロール名削除
        // https://dev.omni-cuscon.net/SignIn
        var pattern = /^(https?:\/\/)/;
        let replace_domain = domain.replace(pattern,'').split('/');
        
        await this.ascAxios('post',`/Sign/systemParametersCheck`, {
            parameter_type : "default",
        })
        .then(dafault_parameters_result=>{
            let dafault_parameters = dafault_parameters_result.data;

            this.ascAxios('post',`/Sign/systemParametersCheck`, {
                parameter_type : replace_domain[0],
            })
            .then(domain_parameters_result =>{
                let domain_search_parameters = domain_parameters_result.data;
                Object.assign(dafault_parameters, domain_search_parameters);
                dafault_parameters.EXTEN_COUNT = dafault_parameters.EXTEN_COUNT || GlobalConst.COUNT_LIMIT.ExtenCount
                this.setState({systemParameters: dafault_parameters});

            })
        })
    }

    getMyPath = () => {
        return this.props.location.pathname;
    }

    userHasAuthenticated = (authenticated, userInfo) => {
        let isAuthenticated = authenticated;
        userInfo = userInfo || {};

        this.setState({
            isAuthenticated,
            userInfo
        }, async () => {
            // ログイン状態が変化した後に再生設定の同期を行う
            if (isAuthenticated) {
                await this.loadPlaybackSettings();
                await this.loadDownloadSettings();
            }
        });
    };

    authenticating = authenticating => {
        this.setState({isAuthenticating: authenticating});
    };

    async componentDidMount() {
        try {
            
            
            let response = await this.ascAxios("post", "/Sign/check");

            if (response && response.data && response.data.user_id) {
                this.userHasAuthenticated(true, response.data);
                await this.getNotifications();
                await this.loadPlaybackSettings();
                await this.loadDownloadSettings();
                
                if (response.data.company_id) {
                    let cm12_id = response.data.company_id;
                    await this.ascAxios('post', `Common/getCompanyControlParameters`, {
                        cm12_id,
                    })
                    .then(result => {
                        this.setState({userCompanyControlParameters: result.data});
                    })
                    .catch(err => {
                        alert(this.getErrorString(err.response.data));
                    });                
                }

            } else {
                this.historyPush("/SignIn");
            }
        } catch (e) {
            console.error(e);
        }

        this.authenticating(false);
    }

    componentWillMount() {
        window.addEventListener('resize', this.handleWindowSizeChange);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleWindowSizeChange);
    }

    handleWindowSizeChange = () => {
        this.setState({
            width: window.innerWidth,
            appHeight: window.innerWidth < 768 ? "100%" : window.innerHeight - this.state.headerHeight,
            tableHeight: window.innerHeight - this.state.headerHeight - 85,
        });
    };

    setHistoryLock = (lock) => {
        this.setState({historyLock: lock});
    }

    historyPush = async (target) => {
        if (this.state.isAuthenticated) await this.getNotifications();
        if (!this.state.historyLock || window.confirm(this.getMyLangText(this.state.lang).Message.InputDataResetBack)) {
            this.setHistoryLock(false);
            this
                .props
                .history
                .push(target);
        }
    };

    getMyLangText = (lang) => {
        let langArr = [
            "Body",
            "Header",
            "Message",
            "MultiSelect",
            "SelectOption",
            "SideBar",
            "Table",
            "Time",
            "CompanyControlParametersOption",
            "Value"
        ];

        let langObj = {};

        langArr.forEach(row => {
            langObj[row] = tryRequire(`./lang/${lang}/Elements/${row}`) ? tryRequire(`./lang/${lang}/Elements/${row}`).default : require(`./lang/ja/Elements/${row}`).default;
        });

        return langObj;
    }
    getCharaLimit = () => {
        let limitObj = [];
        limitObj = require(`./chara_limit`).default;
        return limitObj;
    }

    getCurrentPermission = () => {
        if (this.state.userInfo.permission_json_data) {
            for (let i = 0; i < this.state.userInfo.permission_json_data.length; i++) {
                let controller_id = this.state.userInfo.permission_json_data[i].controller_id;
                //親画面の権限（編集）で子画面を管理するため、親画面名を取得する
                let path = this.props.location.pathname.split("/")[1];
                if (controller_id.toLowerCase() === path.toLowerCase()) {
                    return this.state.userInfo.permission_json_data[i];
                }
            };
        }
        return {};
    }

    // URL直打ちなどのアクセス判定用: 子画面は子→親の順で権限を探す（見つからなければ従来通り親画面の権限）
    getAccessPermission = () => {
        if (this.state.userInfo.permission_json_data) {
            const paths = this.props.location.pathname.split("/").filter(Boolean);

            // 子画面（/Parent/Child...）の場合のみ、後ろから（子→親）で controller_id を探索
            if (paths.length >= 2) {
                for (let p = paths.length - 1; p >= 1; p--) {
                    const target = paths[p];
                    for (let i = 0; i < this.state.userInfo.permission_json_data.length; i++) {
                        const controller_id = this.state.userInfo.permission_json_data[i].controller_id;
                        if (controller_id && controller_id.toLowerCase() === target.toLowerCase()) {
                            return this.state.userInfo.permission_json_data[i];
                        }
                    }
                }
            }
        }

        // 親画面 or 該当権限が見つからない場合は従来挙動
        return this.getCurrentPermission();
    }

    // 通知を全体的に管理
    getNotifications = async () => {
        try {
            let result = await this.ascAxios('post', `Common/getNotifications`);

            this.setState({
                notification_flag: result.data.length > 0 ? true : false,
                notifications: result.data
            });
        } catch (err) {
            console.error(err);
        }
    }

    render() {
        let childProps = {
            currentPermission: this.getAccessPermission(),
            isAuthenticated: this.state.isAuthenticated,
            userHasAuthenticated: this.userHasAuthenticated,
            setHistoryLock: this.setHistoryLock,
            historyPush: this.historyPush,
            lang: this.state.lang,
            width: this.state.width,
            userInfo: this.state.userInfo,
            getMyPath: this.getMyPath,
            langText: this.getMyLangText(this.state.lang),
            charaLimit: this.getCharaLimit(),
            tableHeight: this.state.tableHeight,
            boardWidth: {

                xxsmall:70,
                xsmall:80,
                small: 100,
                smedium: 120,
                medium: 150,
                large: 170,
                xlarge: 200,
                xxlarge: 230,
                xxxlarge: 280,
                Control: 90,
                LargeControl: 120,
                XLargeControl: 150,
                Date:120,
                modified:128,
                sId: 40,
                id: 60,
                CallNumber:120,
                week: 75,
                UserName:135,
                CallRank: 140
            },
            userCompanyControlParameters: this.state.userCompanyControlParameters,
            systemParameters: this.state.systemParameters,
            notification_flag: this.state.notification_flag,
            notifications: this.state.notifications,
            getNotifications: this.getNotifications,
            playbackSettings: this.state.playbackSettings || { audioSpeed: 1, autoScroll: false },
            savePlaybackSettings: this.savePlaybackSettings,
            downloadSettings: this.state.downloadSettings || { addCallHistoryId: false },
            saveDownloadSettings: this.saveDownloadSettings
        };

        let style =
        {
            backgroundImage: window.innerWidth < 768 ? `url(${loginImg_Mini})`: `url(${this.state.systemParameters["lOGIN_BG"]})`,
        };
        let appContent = <Grid>
                <Col xs={12} sm={12} className="signIn-logo-overview" style={style}>
                    {/* <div className="signIn-logo-string"><img src={loginLogo} class="img-logo"></img></div> */}
                    <div className="signIn-logo-string"><img src={this.state.systemParameters["LOGO"]} class="img-logo"></img></div>
                    <Routes childProps={childProps}/>
                </Col>
                <div className="git-version">
                    {Gitversion.date}<br/>
                    Ver.{Gitversion.version}
                </div>
            </Grid>
        let upperSide = <SideBar childProps={childProps} parentType="upper"/>
        let lowerSide = <SideBar childProps={childProps} parentType="lower"/>

        let permissionList = this.state.userInfo.permission_json_data;
        if (this.state.isAuthenticated) {
            switch (this.props.location.pathname) {
                case "/Forbidden":
                    break;
                case "/SignIn":
                case "/":
                    // ログイン直後もしくは初期画面は最初にread権限があるコンテナへ(一つもなければforbiddenへ)
                    if (permissionList.map(obj => obj.read).filter(value => value).length === 0) {
                        this.props.location.pathname = "/Forbidden";
                        alert(childProps.langText.Message.AuthCheckError);
                    } else {
                        this.props.location.pathname = "/" + permissionList.find(obj => obj.read).controller_id;
                        // ログイン直後の権限セット
                        childProps.currentPermission = this.getAccessPermission();
                    }
                    break;
                default:
                    // アクセスコンテナのread権限が無い場合はforbidden(権限が存在しない場合{}も)
                    if (!this.getAccessPermission().read) {
                        this.props.location.pathname = "/Forbidden";
                        alert(childProps.langText.Message.AuthCheckError);
                    }
                    break;
            }

            appContent = <Grid>
                <Row className="row-upper">
                    <Col xs={12} md={12} id="header-app" className="header-app">
                        <Header childProps={childProps}>
                            {this.state.width < 768 && upperSide}
                        </Header>
                    </Col>
                </Row>
                <Row className="row-lower">
                    <Col xs={12} sm={2} id="sidebar-app" className="sidebar-app" style={{height: this.state.appHeight}}>
                        <ButtonGroup className="sidebar-group" vertical>
                            {this.state.width >= 768 && lowerSide}
                        </ButtonGroup>
                    </Col>
                    <Col xs={12} sm={10} id="routes-app" className="routes-app" style={{height: this.state.appHeight}}>
                        <Routes childProps={childProps}/>
                    </Col>
                </Row>
            </Grid>;
        }

        return (
            !this.state.isAuthenticating ?
            <div className = "App">
                {appContent}
                <div id="asc-block-ui" className="asc-block-ui asc-display-none z-index-1500">
                    <div className="asc-block-icon-box">
                        <ReactLoading className="asc-block-icon" type="spinningBubbles" color="#fff" />
                        <label className="asc-block-label">{childProps.langText.Body.Wait}</label>
                    </div>
                </div>
            </div>
            :
            <div className = "App">
                <div className="asc-block-ui">
                    <div className="asc-block-icon-box">
                        <ReactLoading className="asc-block-icon" type="spinningBubbles" color="#fff" />
                        <label className="asc-block-label">{childProps.langText.Body.Wait}</label>
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(App);
